import { defineMessages } from 'react-intl';

const point10Messages = defineMessages({
    gispoint: {
        id: 'gispoint-point',
        defaultMessage: 'Unknown Point',
    },
});

export default point10Messages;
